
export class ReferenceAnnotationMarkedImages {
  imageName : string;
  pixelX: number;
  pixelY: number;


  constructor(imageName: string, pixelX: number, pixelY: number) {
    this.imageName = imageName;
    this.pixelX = pixelX;
    this.pixelY = pixelY;
  }
}
